// src/pages/dashboard/DashboardSkeleton.jsx
import React from "react";

const SkeletonStat = () => (
  <div className="ds-stat">
    <div className="skeleton skeleton-circle" />
    <div style={{ flex: 1 }}>
      <div className="skeleton skeleton-line" style={{ width: "60%", marginBottom: 8 }} />
      <div className="skeleton skeleton-line" style={{ width: "40%" }} />
    </div>
  </div>
);

export default function DashboardSkeleton() {
  return (
    <>
      {/* هدر */}
      <div className="ds-head">
        <div className="ds-who">
          <div className="skeleton skeleton-avatar" />
          <div style={{ flex: 1 }}>
            <div className="skeleton skeleton-line" style={{ width: 180, marginBottom: 8 }} />
            <div className="skeleton skeleton-line" style={{ width: 120 }} />
          </div>
        </div>

        <div className="ds-clock">
          <div className="skeleton skeleton-line" style={{ width: 90, marginBottom: 8 }} />
          <div className="skeleton skeleton-line" style={{ width: 160, marginRight: "auto" }} />
        </div>
      </div>

      {/* ۴ کارت آمار */}
      <div className="ds-grid">
        {[1, 2, 3, 4].map((i) => (
          <SkeletonStat key={i} />
        ))}
      </div>

      {/* کارت گزارش فروش */}
      <div className="card">
        <div className="skeleton skeleton-title" />
        <div className="ds-grid ds-grid-3">
          {[1, 2, 3].map((i) => (
            <SkeletonStat key={i} />
          ))}
        </div>
      </div>

      {/* کارت بالانس */}
      <div className="card">
        <div className="skeleton skeleton-title" />
        <div className="ds-balance">
          <div className="skeleton skeleton-balance-main" />
          <div className="ds-balance-side">
            <div className="skeleton skeleton-line" style={{ width: "80%", marginBottom: 12 }} />
            <div className="skeleton skeleton-line" style={{ width: "70%" }} />
          </div>
        </div>
      </div>

      <style>{`
        .skeleton {
          background: linear-gradient(
            90deg,
            var(--border) 25%,
            var(--border-strong) 50%,
            var(--border) 75%
          );
          background-size: 200% 100%;
          animation: skeleton-shimmer 1.4s ease-in-out infinite;
          border-radius: 8px;
        }
        @keyframes skeleton-shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
        .skeleton-circle {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          flex-shrink: 0;
        }
        .skeleton-avatar {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          flex-shrink: 0;
        }
        .skeleton-line {
          height: 14px;
          border-radius: 6px;
        }
        .skeleton-title {
          height: 22px;
          width: 40%;
          margin-bottom: 20px;
        }
        .skeleton-balance-main {
          height: 120px;
          width: 100%;
          border-radius: 16px;
          margin-bottom: 16px;
        }
      `}</style>
    </>
  );
}